// extracted by mini-css-extract-plugin
export var grid = "_23-0";
export var span1 = "_23-2";
export var span10 = "_23-b";
export var span10L = "_23-z";
export var span10M = "_23-n";
export var span10Xl = "_23-1b";
export var span11 = "_23-c";
export var span11L = "_23-10";
export var span11M = "_23-o";
export var span11Xl = "_23-1c";
export var span12 = "_23-d";
export var span12L = "_23-11";
export var span12M = "_23-p";
export var span12Xl = "_23-1d";
export var span1L = "_23-q";
export var span1M = "_23-e";
export var span1Xl = "_23-12";
export var span2 = "_23-3";
export var span2L = "_23-r";
export var span2M = "_23-f";
export var span2Xl = "_23-13";
export var span3 = "_23-4";
export var span3L = "_23-s";
export var span3M = "_23-g";
export var span3Xl = "_23-14";
export var span4 = "_23-5";
export var span4L = "_23-t";
export var span4M = "_23-h";
export var span4Xl = "_23-15";
export var span5 = "_23-6";
export var span5L = "_23-u";
export var span5M = "_23-i";
export var span5Xl = "_23-16";
export var span6 = "_23-7";
export var span6L = "_23-v";
export var span6M = "_23-j";
export var span6Xl = "_23-17";
export var span7 = "_23-8";
export var span7L = "_23-w";
export var span7M = "_23-k";
export var span7Xl = "_23-18";
export var span8 = "_23-9";
export var span8L = "_23-x";
export var span8M = "_23-l";
export var span8Xl = "_23-19";
export var span9 = "_23-a";
export var span9L = "_23-y";
export var span9M = "_23-m";
export var span9Xl = "_23-1a";
export var stretch = "_23-1";